var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"flex flex-wrap"},_vm._l((_vm.rooms),function(ref){
var id = ref.id;
var name = ref.name;
var status = ref.status;
var group = ref.group;
return _c('li',{key:id,staticClass:"p-4 w-1/5"},[_c('router-link',{staticClass:"block w-full py-4 px-6 border border-gray-400 rounded hover__bg-blue-100 text-base leading-normal",attrs:{"to":{ name: 'room-details', params: { buildingId: _vm.buildingId, groupId: _vm.buildingGroupId, roomGroupId: group.id, roomId: id }}}},[_c('span',[_vm._v(_vm._s(name))])])],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }